import React from 'react';

const BackArrow: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11.25 3.5L2.75 12M2.75 12L11.25 20.5M2.75 12H21.5" stroke="#F14157" strokeLinecap="round" />
  </svg>
);

export default BackArrow;
